import { Component, OnDestroy,ElementRef, OnInit, ViewChild,Output,EventEmitter,ViewEncapsulation, inject } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { RoutesService } from 'app/modules/task/administration/services/routes.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { Rest } from 'app/rest/rest_client';
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { RestExt } from 'app/services/rest-client-extension';
import { DelegationFormComponent } from '../delegation-form/delegation-form.component';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { TranslateService } from '@ngx-translate/core';
import Routes= Rest_task.Route;
import { DelegationService } from 'app/modules/task/administration/services/delegation.service';
import { UserService } from 'app/rest/user.service';
import { PRIME_NG_CONFIG } from 'primeng/config';

@Component({
    selector: 'app-delegation-list',
    templateUrl: './delegation-list.component.html',
    styleUrls: ['./delegation-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [DelegationService, UserTimePipe, UserService],
    standalone: false
})

export class DelegationListComponent extends
 EntityListComponent<Rest_task.Delegation> implements OnInit{
    date_now = Date.now() - 24 * 60 * 60 * 1000;
    EnabledFilter: SelectItem[];
 
    @ViewChild(DelegationFormComponent, {static: true}) delegationForm: DelegationFormComponent;
 
    user: Rest.User;
    private config = inject(PRIME_NG_CONFIG);
    //****************** */
    constructor(
       protected  delegationService: DelegationService,
        protected confirmationservice: ConfirmationService,
        protected notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected translate: TranslateService,
        public userService: UserService,
     ) {
        super(
            delegationService,
            confirmationservice,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime
        );
         this.fetchEntityBeforeShowUpdateForm = true;
         this.config.translation = {
          apply: this.translate.instant('general.filters.apply'),
          clear: this.translate.instant('general.filters.clear')
        }
 
    }


    ngOnInit() {
        super.ngOnInit();
        this.hasEntityFilters = false;
        this.form = this.delegationForm;
        if (this.authenticationService.user.delegUserData== null){
          this. getUsers(this.authenticationService.user.id);
       }
 
    }
    getUsers(userId) {
      const promise = new Promise<void>((resolve, reject) => {
        //Load the filters and page if requested and the entity can be filtered by other entities
  
        //If paginationRequest is null create a new one
        let paginationRequest = RestExt.firstPageRequest();
        const that = this;
  
        this.userService
          .userAllDataTask(userId)
          .then(
            function (response) {
              //Usuaris
              that.authenticationService.user.delegUserData = response.delegUserData.map(item => Object.assign({}, item));
             
            },
  
            function (error) {
            },
          )
          .catch(function (reason) {
            resolve();
          });
  
      });
      return promise;
    }
 
    afterLoad() {
 
     }
    public showDelegationFormComponent(route: Rest_task.Delegation): void {
        this.form = this.delegationForm;
        this.editDialog(route);
    }
    //new functions
    protected handleError(err, that) {
        that.errors = {};
        if (typeof err === 'string') {
            try {
                err = JSON.parse(err);
                if ((err.class = 'AtlantisMessage')) {
                    this.notificationsService.add(
                        err.type == 'Warning' ? Severity.warn : Severity.error,
                        this.translate.instant('i18nMigrated.x2'),
                        err.message,
                    );
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    deleteDelegation(delegation){
        try {
      let that = this;

      // Confirm with a dialog
      that.confirmationService.confirm({
        message:  this.translate.instant("tableManagement.delegations.deletedelegation"),
        acceptLabel: this.translate.instant("general.yes"),
        rejectLabel: this.translate.instant("general.no"),
        
        accept: () => {
          // Call the service to delete the order package
          that.delegationService .deleteDelegation(delegation).then((responseFlag) => {
            if (responseFlag) {
              // Remove the package from the array
            this.refresh();
              that.notificationsService.add(Severity.success, "ok", this.translate.instant("tableManagement.delegations.deletedelegationok"));
            } else {
              that.notificationsService.add(Severity.error, "error", this.translate.instant("tableManagement.delegations.deletedelegationerror"));
            }
          })
            .catch((error) => {
              console.error('Error deleteOrderPackage:', error);
              that.notificationsService.add(Severity.error, "error", this.translate.instant("tableManagement.delegations.deletedelegationerror"));
            });
        },
      });
    } catch (error) {
      console.error(error);
    }    
    }

}
 

